// @flow

import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import LicenseNumberInput from './LicenseNumberInput';

// Actions
import {
  setLicenseNumber,
  setObfuscatedBy
} from 'store/reducers/appointment/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';
import { resetObfuscatedContactInfo } from 'store/reducers/appointment/contactInfo/actions';

// Selectors
import { getVehicleProperty } from 'store/reducers/appointment/selectors';
import {
  getIsObfuscated,
  getObfuscatedBy
} from 'store/reducers/appointment/contactInfo/selectors';
import {
  isRegistrationNumEnabled,
  isLicenseNumberValid
} from 'store/reducers/dealerSettings/selectors';

// Types
import type { State } from 'types/redux';
import type { Props } from './LicenseNumberInput';

function mapStateToProps(state: State): $Shape<Props> {
  return {
    isRegistrationNumEnabled: isRegistrationNumEnabled(state),
    isObfuscated: getIsObfuscated(state),
    obfuscatedBy: getObfuscatedBy(state),
    licenseNumber: getVehicleProperty(state)('licenseNumber'),
    isLicenseNumberValid: isLicenseNumberValid(state)
  };
}

const mapDispatchToProps = {
  setLicenseNumber,
  setObfuscatedBy,
  gtmUserEvent,
  resetObfuscatedContactInfo
};

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(LicenseNumberInput);



// WEBPACK FOOTER //
// ./src/components/molecules/LicenseNumberInput/LicenseNumberInputContainer.js